import { shareReplay } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ApiService } from "../../../services/api";
@Injectable({
  providedIn: "root",
})
export class EmployeeListService {
  token = this.cookieService.get("token");
  GLOBALURL = this.ApiService.getBaseURL();
  storeId = this.cookieService.get("storeId");
  merchantId = this.cookieService.get("merchantId");

  constructor(private ApiService: ApiService,private http: HttpClient, private cookieService: CookieService) { }

  addEmployee(payload: any): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/user/invite", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }
  addEmployeeAdmin(payload: any): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/user/invite/super", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }
  updateEmployee(payload): Observable<any> {
    return this.http
      .put(this.GLOBALURL + "/employee", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }

  updateEmployeeSchedule(payload): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/employeeSchedule", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }
  addShift(payload): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/shift", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }

  getEmployeeWorkingHours(): Observable<any> {
    return this.http
      .get(this.GLOBALURL + "/workingHour/report", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  getEmployeeSchedule(payload): Observable<any> {
    return this.http.get<any>(this.GLOBALURL + `/employeeSchedule?employeeId=${payload}`).pipe(shareReplay(1));
  }
  getShift(merchantId , storeId): Observable<any> {
    return this.http.get<any>(this.GLOBALURL + `/shift/query?merchantId=${merchantId}&storeId=${storeId}`).pipe(shareReplay(1));
  }
  getShiftById(id): Observable<any> {
    return this.http.get<any>(this.GLOBALURL + `/shift?shiftId=${id}`).pipe(shareReplay(1));
  }

  updateShift(payload): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/shift", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }

  updateWorkingHour(payload): Observable<any> {
    return this.http
      .post(this.GLOBALURL + "/workingHour/time", payload, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }

  getEmployeeShifts(): Observable<any> {
    return this.http
      .get(this.GLOBALURL + "/employeeSchedule", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  uploadImg(imgUrl: any): Observable<any> {
    return this.http
      .put(`${this.GLOBALURL}/upload?path=images/employeePhoto/`, imgUrl, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      })
  }

  getAllEmployees(): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/employee?storeId=${this.storeId}`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }
  getAllActiveEmployees(): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/employee?storeId=${this.storeId}&status=1`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  getEmployee(employeeId: any): Observable<any> {
    return this.http
      .get(this.GLOBALURL + `/employee?employeeId=${employeeId}`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  getAllRoles(): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/role`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  workingHour(payload: any, isClockInBreak = false): Observable<any> {
    if (isClockInBreak) {
      return this.http
        .post(`${this.GLOBALURL}/workingHour?storeId=${this.storeId}&offset=0`, payload, {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.token,
          }),
        })
    } else {
      return this.http
        .put(`${this.GLOBALURL}/workingHour?storeId=${this.storeId}&offset=0`, payload, {
          headers: new HttpHeaders({
            "Content-Type": "application/json",
            Authorization: this.token,
          }),
        })
    }
  }

  getAllReports(startTodayTime: any, endOfWeekTime: any): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/workingHour/report?startDate=${startTodayTime}&endDate=${endOfWeekTime}&storeId=${this.storeId}`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
  }

  getAllDepartments(): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/department?storeId=${this.storeId}`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  getAllJopTypes(): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/jobtype?storeId=${this.storeId}`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  getJobTypes(params): Observable<any> {
    return this.http
      .get(`${this.GLOBALURL}/jobtype`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
        params: params,
      })
      .pipe(shareReplay(1));
  }

  getStore(): Observable<any> {
    return this.http
      .get(this.GLOBALURL + "/store", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }

  uploadEmployee(payload) {
    return this.http.post(this.GLOBALURL + "/employee/import", payload, {
      headers: new HttpHeaders({
        enctype: "multipart/form-data",
        Authorization: this.token,
      }),
      params: new HttpParams()
        .set("storeId", this.storeId)
        .set("merchantId", this.merchantId),
      reportProgress: true,
      observe: "events",
    });
  }

  exportEmployee() {
    return this.http.post(
      this.GLOBALURL + "/employee/export",
      {
        storeId: this.storeId,
        merchantId: this.merchantId,
      },
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      }
    );
  }

  resentInvitation(payload): Observable<any> {
    return this.http.post(this.GLOBALURL + `/user/resendinvite`,payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
    });
  }

  updatePassword(payload) {
    return this.http.post(
      this.GLOBALURL + "/user/updateEmployeePassword",
      payload,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        }),
      }
    );
  }

  deleteEmployee(employeeId): Observable<any> {
    return this.http.delete(this.GLOBALURL + `/employee?storeId=${this.storeId}&employeeId=${employeeId}`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
    });
  }



  unarchiveEmployee(payload): Observable<any> {
    return this.http.patch(this.GLOBALURL + `/employee`, payload, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
    });
  }

  permanentlyDeleteEmployee(employeeId): Observable<any> {
    return this.http.delete(this.GLOBALURL + `/employee?storeId=${this.storeId}&employeeId=${employeeId}&isPermanent=1`, {
      // return this.http.delete(this.GLOBALURL + `/employee?employeeId=${employeeId}&isPermanent=1`, {
      headers: new HttpHeaders({
        "Content-Type": "application/json",
        Authorization: this.token,
      }),
    });
  }
  
  getEmployeeCustomQuery(): Observable<any> {
    return this.http
      .get(this.GLOBALURL + "/employee/customQuery", {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.token,
        })
      })
      .pipe(shareReplay(1));
  }
}
